/** コンサルタント 案件メンバー：メンバー種別 社内メンバー */
export const RFP_OFFER_MEMBER_MEMBER_TYPE_COMPANY_VALUE = 1;
/** コンサルタント 案件メンバー：メンバー種別 社内メンバー */
export const RFP_OFFER_MEMBER_MEMBER_TYPE_COMPANY = {
    label: '社内メンバー',
    value: RFP_OFFER_MEMBER_MEMBER_TYPE_COMPANY_VALUE,
};
/** コンサルタント 案件メンバー：メンバー種別 共同提案メンバー（社外） */
export const RFP_OFFER_MEMBER_MEMBER_TYPE_OUTSIDE_VALUE = 2;
/** コンサルタント 案件メンバー：メンバー種別 共同提案メンバー（社外） */
export const RFP_OFFER_MEMBER_MEMBER_TYPE_OUTSIDE = {
    label: '共同提案メンバー（社外）',
    value: RFP_OFFER_MEMBER_MEMBER_TYPE_OUTSIDE_VALUE,
};
/** コンサルタント 案件メンバー：メンバー種別一覧 */
export const RFP_OFFER_MEMBER_MEMBER_TYPES = [
    RFP_OFFER_MEMBER_MEMBER_TYPE_COMPANY,
    RFP_OFFER_MEMBER_MEMBER_TYPE_OUTSIDE,
];
